// components/MobileNav.js
"use client";

import { useEffect, useRef } from "react";
import Link from "next/link";

const DEFAULT_LINKS = [
  { href: "/services", label: "How Cipher helps" },
  { href: "/signals", label: "Intelligence" },
  { href: "/approach", label: "Approach" },
  { href: "/about", label: "About" },
  { href: "/resources", label: "Resources" },
  { href: "/contact", label: "Contact" }
];

export default function MobileNav({ links = DEFAULT_LINKS }) {
  const dialogRef = useRef(null);

  const openMenu = () => dialogRef.current?.showModal();
  const closeMenu = () => dialogRef.current?.close();

  useEffect(() => {
    const breakpoint = window.matchMedia("(min-width: 1051px)");
    const closeAtDesktop = (event) => {
      if (event.matches && dialogRef.current?.open) closeMenu();
    };

    closeAtDesktop(breakpoint);
    breakpoint.addEventListener("change", closeAtDesktop);
    return () => breakpoint.removeEventListener("change", closeAtDesktop);
  }, []);

  return (
    <div className="cig-mobile-nav">
      <button
        type="button"
        onClick={openMenu}
        className="cig-mobile-nav__trigger"
        aria-haspopup="dialog"
        aria-controls="mobile-menu"
      >
        Menu
      </button>

      <dialog
        ref={dialogRef}
        id="mobile-menu"
        className="cig-mobile-nav__dialog"
        aria-label="Website navigation"
        onClick={(event) => {
          if (event.target === event.currentTarget) closeMenu();
        }}
      >
        <div className="cig-mobile-nav__panel">
          <div className="cig-mobile-nav__topline">
            <span className="cig-section-label">Navigation</span>
            <button type="button" onClick={closeMenu} className="cig-mobile-nav__close">
              Close
            </button>
          </div>

          <nav aria-label="Mobile navigation" className="cig-mobile-nav__links">
            {links.map((item, index) => (
              <Link key={item.href} href={item.href} onClick={closeMenu} className="cig-mobile-nav__link">
                <span className="cig-mobile-nav__number" aria-hidden="true">
                  {String(index + 1).padStart(2, "0")}
                </span>
                <span>{item.label}</span>
              </Link>
            ))}
          </nav>

          <Link href="/contact" onClick={closeMenu} className="cig-btn-primary cig-mobile-nav__cta">
            Start with a decision
          </Link>
        </div>
      </dialog>
    </div>
  );
}
